/* Sunfinity storefront scripts. No framework. No third-party calls.
 *
 * 1. Analytics events (Shopify customer events). NEVER sends names, phone numbers,
 *    enquiry text, artwork links or anything typed by the visitor.
 * 2. Quotation form: prefill from the link, conditional fields, accessible
 *    validation, WhatsApp draft, short-lived draft that survives a failed submit.
 */
(function () {
  'use strict';

  var CATEGORIES = ['album', 'printing', 'packaging', 'spaces', 'other', 'guide'];
  var DRAFT_KEY = 'sf_quote_draft_v1';
  var DRAFT_TTL_MS = 30 * 60 * 1000;

  /* ---------- analytics (no personal data, ever) ---------- */
  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {
      /* analytics must never break the page */
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-sf-whatsapp]') : null;
    if (link) {
      // A click only means the visitor opened a WhatsApp draft. It is NOT a confirmed lead.
      publish('sf_whatsapp_click', { surface: link.getAttribute('data-sf-surface') || 'site' });
    }
  });

  /* ---------- helpers ---------- */
  function cleanText(value, max) {
    return String(value == null ? '' : value)
      .replace(/[\u0000-\u001F\u007F]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  }

  function isValidHandle(value) {
    return /^[a-z0-9][a-z0-9-]{0,254}$/i.test(value);
  }

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  /* ---------- quotation form ---------- */
  function initQuoteForm(root) {
    var form = root.querySelector('[data-sf-form]');
    if (!form) return;

    var success = root.querySelector('[data-sf-success]');
    var serverErrors = root.querySelector('[data-sf-server-errors]');
    var summary = root.querySelector('[data-sf-summary]');
    var summaryList = root.querySelector('[data-sf-summary-list]');
    var submitBtn = form.querySelector('[data-sf-submit]');
    var waBtn = root.querySelector('[data-sf-wa-compose]');
    var chip = root.querySelector('[data-sf-product-chip]');
    var chipText = root.querySelector('[data-sf-product-text]');
    var chipClear = root.querySelector('[data-sf-product-clear]');
    var productInput = form.querySelector('[data-sf-product-field]');
    var productLinkInput = form.querySelector('[data-sf-product-link-field]');
    var configInput = form.querySelector('[data-sf-config-field]');
    var intentInput = form.querySelector('[data-sf-intent-field]');
    var started = false;

    form.noValidate = true; // we show our own accessible error summary; native validation stays as no-JS fallback

    /* --- success page: clear any draft, tell analytics, focus message --- */
    if (success) {
      try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) { /* ignore */ }
      publish('sf_quote_submitted', {});
      success.setAttribute('tabindex', '-1');
      success.focus({ preventScroll: false });
      return;
    }

    /* --- category panels --- */
    var radios = form.querySelectorAll('input[name="sf_category_choice"]');
    var panels = form.querySelectorAll('[data-sf-detail]');
    var categoryField = form.querySelector('[data-sf-category-field]');

    var currentCategory = 'guide';
    function setCategory(value) {
      var exists = form.querySelector('input[name="sf_category_choice"][value="' + value + '"]');
      if (CATEGORIES.indexOf(value) === -1 || !exists) value = 'guide';
      currentCategory = value;
      var chosen = form.querySelector('input[name="sf_category_choice"][value="' + value + '"]');
      Array.prototype.forEach.call(radios, function (r) {
        r.checked = r.value === value;
      });
      // Human-readable label goes into the email
      if (categoryField) categoryField.value = chosen ? chosen.getAttribute('data-label') : value;
      Array.prototype.forEach.call(panels, function (panel) {
        var show = panel.getAttribute('data-sf-detail') === value;
        panel.hidden = !show;
        // Disabled inputs are not submitted, so the email only contains relevant fields.
        Array.prototype.forEach.call(panel.querySelectorAll('input, select, textarea'), function (el) {
          el.disabled = !show;
        });
      });
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', function () {
        setCategory(r.value);
      });
    });

    /* --- audience controls company field --- */
    var audienceRadios = form.querySelectorAll('input[name="sf_audience_choice"]');
    var audienceField = form.querySelector('[data-sf-audience-field]');
    var companyWrap = form.querySelector('[data-sf-company]');
    function setAudience(value) {
      if (audienceField) audienceField.value = value;
      if (companyWrap) {
        var show = value === 'Business' || value === 'Photographer or studio';
        companyWrap.hidden = !show;
        Array.prototype.forEach.call(companyWrap.querySelectorAll('input'), function (el) {
          el.disabled = !show;
        });
      }
    }
    Array.prototype.forEach.call(audienceRadios, function (r) {
      r.addEventListener('change', function () {
        setAudience(r.value);
      });
    });

    /* --- prefill from the link (whitelisted, escaped by textContent / .value only) --- */
    var startCategory = param('category');
    startCategory = startCategory && CATEGORIES.indexOf(startCategory.toLowerCase()) !== -1 ? startCategory.toLowerCase() : 'guide';
    setCategory(startCategory);

    var checkedAudience = form.querySelector('input[name="sf_audience_choice"]:checked');
    setAudience(checkedAudience ? checkedAudience.value : '');

    var handle = param('product');
    if (handle && isValidHandle(handle)) {
      var title = cleanText(param('title') || handle.replace(/-/g, ' '), 160);
      if (productInput) productInput.value = title;
      if (productLinkInput) productLinkInput.value = window.location.origin + '/products/' + handle;
      if (chip && chipText) {
        chipText.textContent = title; // textContent, never innerHTML
        chip.hidden = false;
      }
    } else {
      if (productInput) productInput.disabled = true;
      if (productLinkInput) productLinkInput.disabled = true;
    }
    var config = cleanText(param('config') || '', 400);
    if (configInput) {
      if (config) {
        configInput.value = config;
        if (chip && chipText) { chipText.textContent = chipText.textContent + (chipText.textContent ? ' - ' : '') + config; chip.hidden = false; }
      } else {
        configInput.disabled = true;
      }
    }
    if (param('intent') === 'enquire' && intentInput) {
      intentInput.value = 'Enquiry (not a priced quote request)';
    } else if (intentInput) {
      intentInput.disabled = true;
    }
    if (chipClear) {
      chipClear.addEventListener('click', function () {
        if (productInput) { productInput.value = ''; productInput.disabled = true; }
        if (productLinkInput) { productLinkInput.value = ''; productLinkInput.disabled = true; }
        if (configInput) { configInput.value = ''; configInput.disabled = true; }
        if (chip) chip.hidden = true;
      });
    }

    /* --- restore a draft left by a failed submit (tab-scoped, 30 min, cleared on success) --- */
    var restored = false;
    try {
      var raw = sessionStorage.getItem(DRAFT_KEY);
      if (raw) {
        var draft = JSON.parse(raw);
        if (draft && Date.now() - draft.t < DRAFT_TTL_MS && draft.v) {
          Object.keys(draft.v).forEach(function (name) {
            var el = form.elements[name];
            if (!el || el.type === 'hidden' || el.type === 'radio') return;
            el.value = draft.v[name];
          });
          if (draft.c) setCategory(draft.c);
          if (draft.a) {
            Array.prototype.forEach.call(audienceRadios, function (r) { r.checked = r.value === draft.a; });
            setAudience(draft.a);
          }
          restored = true;
        } else {
          sessionStorage.removeItem(DRAFT_KEY);
        }
      }
    } catch (e) { /* storage blocked: fine, the form still works */ }

    var restoredNote = root.querySelector('[data-sf-restored]');
    if (restored && restoredNote) restoredNote.hidden = false;
    var clearBtn = root.querySelector('[data-sf-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) { /* ignore */ }
        form.reset();
        setCategory('guide');
        setAudience('');
        if (restoredNote) restoredNote.hidden = true;
      });
    }

    if (serverErrors) {
      serverErrors.setAttribute('tabindex', '-1');
      serverErrors.focus();
    }

    /* --- first interaction = quote started (no values are sent) --- */
    form.addEventListener('input', function () {
      if (!started) {
        started = true;
        publish('sf_quote_start', { category: currentCategory });
      }
    }, { once: false });

    /* --- validation --- */
    function labelFor(el) {
      var label = form.querySelector('label[for="' + el.id + '"]');
      return label ? cleanText(label.firstChild ? label.firstChild.textContent : label.textContent, 80) : el.name;
    }

    function setError(el, message, errors) {
      var errId = el.id + '-error';
      var holder = form.querySelector('#' + errId);
      if (!holder) {
        holder = document.createElement('p');
        holder.id = errId;
        holder.className = 'sf-field__error';
        el.closest('.sf-field').appendChild(holder);
      }
      holder.textContent = message;
      el.setAttribute('aria-invalid', 'true');
      var describedBy = (el.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (describedBy.indexOf(errId) === -1) describedBy.push(errId);
      el.setAttribute('aria-describedby', describedBy.join(' '));
      errors.push({ el: el, message: message });
    }

    function clearErrors() {
      Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid="true"]'), function (el) {
        el.removeAttribute('aria-invalid');
        var errId = el.id + '-error';
        var describedBy = (el.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return id && id !== errId; });
        if (describedBy.length) el.setAttribute('aria-describedby', describedBy.join(' '));
        else el.removeAttribute('aria-describedby');
      });
      Array.prototype.forEach.call(form.querySelectorAll('.sf-field__error'), function (p) {
        if (p.parentNode) p.parentNode.removeChild(p);
      });
    }

    function validate() {
      var errors = [];
      clearErrors();
      Array.prototype.forEach.call(form.querySelectorAll('[data-sf-required]'), function (el) {
        if (el.disabled || el.closest('[hidden]')) return;
        if (!String(el.value || '').trim()) {
          setError(el, 'Please fill in: ' + labelFor(el), errors);
        }
      });
      var phone = form.querySelector('[data-sf-phone]');
      if (phone && phone.value.trim() && !phone.getAttribute('aria-invalid')) {
        var digits = phone.value.replace(/\D/g, '');
        if (digits.length < 10 || digits.length > 13) {
          setError(phone, 'Enter a mobile number with at least 10 digits', errors);
        }
      }
      var email = form.querySelector('[data-sf-email]');
      if (email && email.value.trim() && !email.getAttribute('aria-invalid')) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
          setError(email, 'Enter an email address like name@example.com', errors);
        }
      }
      var pin = form.querySelector('[data-sf-pincode]');
      if (pin && pin.value.trim() && !/^\d{6}$/.test(pin.value.trim())) {
        setError(pin, 'A pincode has 6 digits', errors);
      }
      return errors;
    }

    function showSummary(errors) {
      if (!summary || !summaryList) return;
      summaryList.textContent = '';
      errors.forEach(function (err) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + err.el.id;
        a.textContent = err.message;
        a.addEventListener('click', function (ev) {
          ev.preventDefault();
          err.el.focus();
        });
        li.appendChild(a);
        summaryList.appendChild(li);
      });
      summary.hidden = false;
      summary.setAttribute('tabindex', '-1');
      summary.focus();
    }

    form.addEventListener('submit', function (event) {
      var errors = validate();
      if (errors.length) {
        event.preventDefault();
        showSummary(errors);
        return;
      }
      if (summary) summary.hidden = true;

      // Keep what was typed ONLY until the server answers, so a failed send does not lose it.
      try {
        var values = {};
        Array.prototype.forEach.call(form.elements, function (el) {
          if (!el.name || el.disabled || el.type === 'hidden' || el.type === 'radio' || el.type === 'submit') return;
          values[el.name] = el.value;
        });
        var aud = form.querySelector('input[name="sf_audience_choice"]:checked');
        sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
          t: Date.now(),
          c: currentCategory,
          a: aud ? aud.value : '',
          v: values
        }));
      } catch (e) { /* ignore */ }

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        var label = submitBtn.querySelector('[data-sf-submit-label]');
        if (label) label.textContent = 'Sending...';
      }
    });

    // Back/forward cache: never leave the button stuck in "Sending..."
    window.addEventListener('pageshow', function () {
      if (submitBtn) {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.classList.remove('loading');
        var label = submitBtn.querySelector('[data-sf-submit-label]');
        if (label) label.textContent = label.getAttribute('data-default') || 'Send my enquiry';
      }
    });

    /* --- WhatsApp draft built from what is typed so far. The visitor must press send. --- */
    if (waBtn) {
      waBtn.addEventListener('click', function (event) {
        var number = waBtn.getAttribute('data-wa-number') || '';
        if (!number) return;
        event.preventDefault();
        function val(name) {
          var el = form.elements[name];
          return el && !el.disabled ? cleanText(el.value, 400) : '';
        }
        var lines = ['Hi Sunfinity, I would like a quote.'];
        var category = currentCategory;
        var catLabel = form.querySelector('input[name="sf_category_choice"][value="' + category + '"]');
        if (catLabel) {
          var lbl = form.querySelector('label[for="' + catLabel.id + '"]');
          if (lbl) lines.push('Looking for: ' + cleanText(lbl.textContent, 80));
        }
        if (val('contact[Product]')) lines.push('Product: ' + val('contact[Product]'));
        if (val('contact[Configuration]')) lines.push('Configuration: ' + val('contact[Configuration]'));
        if (val('contact[Quantity]')) lines.push('Quantity: ' + val('contact[Quantity]'));
        if (val('contact[body]')) lines.push('Details: ' + val('contact[body]'));
        if (val('contact[name]')) lines.push('Name: ' + val('contact[name]'));
        if (val('contact[City]')) lines.push('City/pincode: ' + val('contact[City]'));
        var text = lines.join('\n').slice(0, 900);
        var url = 'https://wa.me/' + number.replace(/\D/g, '') + '?text=' + encodeURIComponent(text);
        publish('sf_whatsapp_click', { surface: 'quote-form' });
        window.open(url, '_blank', 'noopener');
      });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sf-quote]'), initQuoteForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
